import React, { useEffect, useState } from "react";
import "./style.scss";
import { BreadcrumbHeader } from "../../component/common/BreadcrumbHeader";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import Button from "../../component/common/Button";
import TableWorkItem from "../../component/master_data/TableWorkItem";
import PaginationCommon from "../../component/common/Pagination";
import ModalAddNewWorItem from "../../component/master_data/ModalAddNewWorItem";
import { apiGetListWorkItems } from "../../services/WorkItem";
import { ToastContainer } from "react-toastify";
import { Role } from "../../utils/Role";
import { useSelector } from "react-redux";
const items = [
  {
    title: "Master Data",
  },
  {
    title: "Work item",
  },
];

export default () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecord, setTotalRecord] = useState(0);
  const [listData, setListData] = useState([]);
  const [search, setSearch] = useState("");
  const [sorterInfo, setSorterInfo] = useState({});

  const userRole =
    useSelector((state) => state.auth.userData?.role) ||
    JSON.parse(localStorage.getItem("timesheet_userData"))?.role;

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleInputSearch = (e) => {
    setPageIndex(1);
    setSearch(e.target.value);
  };

  const handleGetListWorkItems = async (page = 1) => {
    let formParams = {
      pageIndex: page,
      pageSize,
      textSearch: search,
      isGetDataWithNullSiteId: false,
      field: sorterInfo?.field ? sorterInfo.field : "",
      order: sorterInfo?.order ? sorterInfo.order : "",
    };
    try {
      const response = await apiGetListWorkItems(formParams);
      if (response?.header?.resultCode === "1000") {
        const dataConfig = response?.records?.listWorkItems?.workItems.map(
          (item, index) => {
            return {
              ...item,
              index: (pageIndex - 1) * pageSize + index + 1,
              key: (pageIndex - 1) * pageSize + index + 1,
            };
          }
        );
        setListData(dataConfig);
        setTotalRecord(response?.records?.listWorkItems?.totalRecord);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    handleGetListWorkItems(pageIndex);
  }, [pageIndex, pageSize, search, sorterInfo]);

  return (
    <>
      <ToastContainer />
      <BreadcrumbHeader title={"Work item"} items={items} />
      <div className="content">
        <ModalAddNewWorItem
          setPageIndex={setPageIndex}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          handleGetListWorkItems={handleGetListWorkItems}
        />
        <div className="report-page setting-page p-4">
          <div className="daily-report">
            <div className="d-flex justify-content-between align-items-center">
              <div className="total-report">
                {totalRecord} {totalRecord > 1 ? "Work items" : "Work item"}
              </div>
              <div className="d-flex gap-2">
                <div className="form-input">
                  <input
                    placeholder="Search"
                    value={search}
                    onChange={handleInputSearch}
                    maxLength={100}
                  />
                  <div className="icon">
                    <SearchOutlined />
                  </div>
                </div>
                {userRole === Role.Admin && (
                  <Button
                    title={"Add"}
                    icon={<PlusOutlined />}
                    handleClick={showModal}
                  />
                )}
              </div>
            </div>
            <div style={{ flexGrow: 1 }}>
              <TableWorkItem
                setSorterInfo={setSorterInfo}
                setPageIndex={setPageIndex}
                listData={listData}
                handleGetListWorkItems={handleGetListWorkItems}
                pageSize={pageSize}
              />
            </div>
            <div className="text-end">
              <PaginationCommon
                totalRecord={totalRecord}
                pageSize={pageSize}
                pageIndex={pageIndex}
                setPageIndex={setPageIndex}
                setPageSize={setPageSize}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
